import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  validationError: {
    color: '#a4262c',
  }
})
